import { Form } from '@/components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: ${COLORS.DARK_ONYX};
  height: 100%;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
`;

export const StyledForm = styled(Form)`
  width: 100%;
  height: 100%;
`;

export const StyledButton = styled(Button)`
  margin-top: auto;
`;
